import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import CreateTeamFormFields from './CreateTeamFormFields';

export default function CreateTeamFormModal({ isOpen, onClose, onSuccess, title = 'Create a New Club' }) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-label={title}>
      <div className="modal-content">
        <h2 className="modal-title">{title}</h2>
        <CreateTeamFormFields onCancel={onClose} onSuccess={onSuccess} />
      </div>
    </div>,
    document.body
  );
}

CreateTeamFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  title: PropTypes.string,
};
